export const optionProps = {
  width: '150px',
  height: { min: '55px' },
  elevation: 'small',
  align: 'center',
  justify: 'center',
};
